import React, { memo } from 'react';
import BlockMarkdown from './BlockMarkdown';
import { extractBlockMarkdown } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

function MarkdownBlock({ block, renderContext }) {
    const content = extractBlockMarkdown(block);
    if (!content) return null;
    return (
        <section className={styles.markdownBlock}>
            {block.title ? <h3 className={styles.blockTitle}>{block.title}</h3> : null}
            <BlockMarkdown content={content} {...renderContext} />
        </section>
    );
}

function UnsupportedBlock({ block, renderContext }) {
    const content = extractBlockMarkdown(block);
    const typeLabel = block?.type || 'unknown';
    return (
        <section className={styles.unsupportedBlock} aria-label={`Unsupported block: ${typeLabel}`}>
            {content ? (
                <BlockMarkdown content={content} {...renderContext} />
            ) : (
                <p className={styles.unsupportedText}>Unsupported response block: {typeLabel}</p>
            )}
        </section>
    );
}

export { MarkdownBlock, UnsupportedBlock };

export default memo(MarkdownBlock);
